import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getRevisionByIdRequest(revisionId) {
  if (!revisionId) {
    return null;
  }
  try {
    const result = await axios.get(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/${encodeURIComponent(revisionId)}`);
    return {
      id: result.data.objectID,
      __clientId: result.data.objectID,
      __syncedWithBackend: true,
      courseId: result.data.courseID,
      portalId: result.data.portalID,
      userId: result.data.userID,
      isActive: result.data.isActive,
      name: result.data.title,
      disabledContentIds: JSON.parse(result.data.content)
    };
  } catch (err) {
    console.log("getRevisionByIdRequest(): an error occurred", err);
    return null;
  }
}

export { getRevisionByIdRequest };
//# sourceMappingURL=request.get-by-id.js.map
